export default __webpack_public_path__ + "static/media/img9.1c1b4243.svg";